﻿import LandingPage from "./LandingPage.svelte";
import PersonalDetails from "./PersonalDetails.svelte";
import ClaimDetails from "./ClaimDetails.svelte";
import ClaimDetailsImpact from "./ClaimDetailsImpact.svelte";
import ClaimDetailsTreatment from "./ClaimDetailsTreatment.svelte";
import DocumentUpload from "./DocumentUpload.svelte";

const confirmationPages = [
	{
		component: LandingPage,
		routeId: "/Registration",
		confirmationHeading: null,
		showEdit: false
	},
	{
		component: PersonalDetails,
		routeId: "/Registration/PersonalDetails",
		confirmationHeading: "Your details"
	},
	{
		component: ClaimDetails,
		routeId: "/Registration/ClaimDetails",
		confirmationHeading: "Your claim details - social media use"
	},
	{
		component: ClaimDetailsImpact,
		routeId: "/Registration/ClaimDetailsImpact",
		confirmationHeading: "Your claim details - impact of social media"
	},
	{
		component: ClaimDetailsTreatment,
		routeId: "/Registration/ClaimDetailsTreatment",
		confirmationHeading: "Your claim details - treatment"
	},
	{
		component: DocumentUpload,
		routeId: "/Registration/DocumentUpload",
		confirmationHeading: "Document Upload"
	}
	// {
	// 	component: DocumentUpload,
	// 	routeId: "/Registration/DocumentUpload",
	// 	confirmationHeading: (model) => {
	// 		const contraceptionId = 400;
	// 		const showDisclaimer =
	// 			model.registrationType == "Individual (Myself)" &&
	// 			model.claimDetailsReactionDetails.diagnosedWithMeningioma === "Yes";

	// 		return showDisclaimer ? "Medical Authority and Document Upload" : "Document Upload";
	// 	},
	// 	hidePage: (formData) => {
	// 		return (
	// 			formData.claimDetailsReactionDetails?.diagnosedWithMeningioma == "No" &&
	// 			formData.claimDetailsReactionDetails?.diagnosedWithRelatedCondition == "No"
	// 		);
	// 	}
	// },
	// {
	// 	component: AdditionalInformation,
	// 	routeId: "/Registration/AdditionalInformation",
	// 	confirmationHeading: "Additional Information",
	// 	hidePage: (formData) => {
	// 		return (
	// 			formData.claimDetailsReactionDetails?.diagnosedWithMeningioma == "No" &&
	// 			formData.claimDetailsReactionDetails?.diagnosedWithRelatedCondition == "No"
	// 		);
	// 	}
	// }
];

export default confirmationPages;
